import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { TrackingHandler } from 'client/tracking/handler';
import { CommonMap } from 'client/tracking/maps/common';
import { buildGlossaryTermBreadcrumbs, buildGlossaryTermContentPath } from 'site-modules/glossary/utils/glossary';
import { GlossaryContent } from 'site-modules/glossary/components/glossary-content/glossary-content';

function GlossaryTermUI({ term, content = null }) {
  useEffect(() => {
    TrackingHandler.useMap(CommonMap);
  }, []);

  if (!content) {
    return null;
  }

  const title = content
    .child('sub-page-1')
    .child('sub-page-1-left-col')
    .child('editorial-header')
    .metadata('title')
    .value();
  const termsContent = content
    .child('sub-page-1')
    .child('sub-page-1-left-col')
    .child('glossary-terms-container')
    .child('glossary-terms');

  return (
    <GlossaryContent
      breadcrumbsData={buildGlossaryTermBreadcrumbs(title, term)}
      title={title}
      termsContent={termsContent.content}
    />
  );
}

GlossaryTermUI.propTypes = {
  term: PropTypes.string.isRequired,
  content: CmsEntities.Content,
};

export const GlossaryTerm = connectToModel(GlossaryTermUI, {
  content: bindToContent(({ term }) => `${buildGlossaryTermContentPath(term)}.withContent`),
});
